import React from 'react';
import { Helmet } from 'react-helmet-async';
import PricingSection from '../components/PricingSection';
import ContactSection from '../components/ContactSection';

export default function Priser() {
  return (
    <div className="bg-white pt-0">
      <Helmet>
        <title>Priser | Gennemskuelige priser uden skjulte gebyrer | Online Tryghed</title>
        <meta name="description" content="Se vores priser på telefon- og fjernsupport samt personligt fremmøde. Vi fakturerer pr. påbegyndt halve time. Alle priser er inkl. moms." />
      </Helmet>

      {/* Pricing Section */}
      <PricingSection />

      {/* Contact Section */}
      <ContactSection />
    </div>
  );
}
